import useSWR from "swr";
import qs from "qs";
import { fetcher, GetPaths } from "@certn/api";
import { useCheckCardContext } from "../../CheckCardContext";
import { components } from "@certn/api/generated-schemas/client-portal";

interface Props {
  shouldFetch: boolean;
  selectFieldInformation?: components["schemas"]["SelectFieldInformationGroup"][];
  includeChildren?: boolean;
}

export function useSelectionEndpointData(props: Props) {
  const { customerGroup } = useCheckCardContext();
  const { includeChildren = false } = props;

  const key =
    props.shouldFetch && props.selectFieldInformation?.length
      ? [
          "selection-endpoints",
          customerGroup,
          includeChildren,
          props.selectFieldInformation,
        ]
      : null;

  const { data, error, isLoading } = useSWR<
    components["schemas"]["CheckOptionsResponse"]
  >(key, async () => {
    let merged: components["schemas"]["CheckOptionsResponse"] = {
      select_options: [],
      children: [],
    };

    for (const fieldInformation of props.selectFieldInformation || []) {
      const url =
        fieldInformation.selection_endpoint +
        qs.stringify(
          {
            customer_group_id: customerGroup,
            include_children: includeChildren,
          },
          { addQueryPrefix: true, arrayFormat: "repeat" }
        );

      const result = await fetcher.request(url as GetPaths);

      // shallow merge — the last response in the list will overwrite earlier responses
      // this is a little fragile and might need refactoring to make it play nicely with mixed results
      merged = {
        ...merged,
        ...(result as object),
      };
    }

    return merged;
  });

  return {
    data: data ?? null,
    isLoading,
    error,
  };
}
